
angular.module('mtic.components.navbar')
.directive('navBarLanguage', function (language, EventManager, $cookies, $timeout, $log) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('language');
      scope.ui = {
        isOpen: false
      }
      scope.isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));
      
      scope.language = language;
      scope.selectLanguage = function(slug){
        scope.ui.isOpen = false; 
        if(!scope.isMobile){
          $timeout(function(){
            scope.ui.isOpen = true;
          }, 200)
        }
        // if (slug !== $cookies.get('bar_language')) {
          language.set(slug)
        // }

      }
      eventManager.listen("language:options:change", function(e){
        scope.languageOptions = language.options
      })
      scope.$watch('ui.isOpen', function(val){
      })

      //console.log(language.getActiveLanguageOptions())
    }
  }
})
